import script from "./HospitalScreenPatientStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalScreenPatientStrip.vue?vue&type=script&setup=true&lang=js"

import "./HospitalScreenPatientStrip.vue?vue&type=style&index=0&id=06d917a6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d917a6"]])

export default __exports__